import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getIsInCheckedMode from 'mini-mail-list-store/lib/utils/getIsInCheckedMode';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';

export const shouldShowFocusedOtherButton = (): boolean =>
    isFocusedInboxEnabled() &&
    getFocusedFilterForTable(getSelectedTableView()) !== FocusedViewFilter.None &&
    !getIsInCheckedMode() &&
    !getListViewStore().shouldShowSearchBox;
